export enum EopStatuses {
  Pending = 'pending',
  Passed = 'passed',
  NotPassed = 'not passed',
  Extended = 'extended',
}

export const EopStatusLabels: Record<EopStatuses, string> = {
  [EopStatuses.Pending]: 'Pending',
  [EopStatuses.Passed]: 'Passed',
  [EopStatuses.NotPassed]: 'Failed',
  [EopStatuses.Extended]: 'Extended',
};
